export type ProductClickAndCollect = {
  productId: number;
  productCode: string;
  colours: Array<ProductClickAndCollectColour>;
  links: Array<string>;
};

export type ProductClickAndCollectColour = {
  colourId: number;
  clickAndCollectable: boolean;
  links: Array<string>;
};
